import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { postApi } from "../../../api/getUser";
import { useDispatch } from "react-redux";
import { setWoTimerMode } from "../../../features/user/userSlice";
import {
  AddFormButton,
  CustomLoader,
} from "../../../shared/components/TableElements";
import TimerModeCards from "../../../shared/components/form/TimerModeCards";
import { useTranslation } from "react-i18next";

const WOTimerModeSetupPopup = ({ show, onSuccess, onError }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [localSelected, setLocalSelected] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleContinue = async () => {
    setLoading(true);
    const res = await postApi(
      { querystring: "update_wo_timer_mode", wo_timer_mode: localSelected },
      "commonNew"
    );
    if (res.success) {
      dispatch(setWoTimerMode(localSelected));
      onSuccess();
    } else {
      setLoading(false);
      onError();
    }
  };

  return (
    <Modal
      show={show}
      centered
      size="lg"
      //backdrop="static"
      keyboard={false}
      onHide={onSuccess}
    >
      <Modal.Body className="p-4">
        <div className="text-center mb-4">
          <SetupBadge>✓ {t("one_time_setup").toUpperCase()}</SetupBadge>
          <h4 className="mt-3 fw-bold">{t("wo_timer_mode_setup_title")}</h4>
          <p style={{ color: "#666" }}>{t("wo_timer_mode_setup_desc")}</p>
        </div>

        <TimerModeCards selected={localSelected} onChange={setLocalSelected} />

        <div className="d-flex justify-content-end mt-4">
          <AddFormButton
            type="button"
            onClick={handleContinue}
            disabled={loading}
          >
            {loading ? <CustomLoader /> : t("continue")}
          </AddFormButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WOTimerModeSetupPopup;

const SetupBadge = styled.span`
  background: #e8f5e9;
  color: #2e7d32;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
`;
